import { MultiSelectFilterType } from './multi-select-filter-type';
import { DataManager } from '@syncfusion/ej2-data';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DropDownConstantsFactory } from '../syncfusion/dropdown-constants-factory';
import { MultiSelectCustomAdaptor } from './multi-select-custom-adaptor';
import { Observable } from 'rxjs';
import { MultiSelectItem } from './multi-select-item';
import { MultiSelectComponent, MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-multi-select-filter',
    templateUrl: './multi-select-filter.component.html',
    styleUrls: ['./multi-select-filter.component.scss'],
    imports: [MultiSelectModule, NgClass]
})
export class MultiSelectFilterComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() public getDataFunction: (searchText: string) => Observable<string[] | MultiSelectItem[]>;
  @Input() public type: MultiSelectFilterType;
  @Input() public isDisabled = false;
  @Input() public closePopupOnSelect = true;
  @Input() public width;
  @Input() public placeholder = '';
  @Input() public set values(values: any[]) {
    this._outputValue = values;
  }

  @Output() public valuesChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  @ViewChild('multiselect') public multiselect: MultiSelectComponent;

  public data: DataManager;
  public fieldsSettings = undefined;

  public get outputValue() {
    return this._outputValue;
  }

  public set outputValue(value: any[]) {
    this._outputValue = value;
    if (this._isInitialized && this._outputValue != null) {
      this.valuesChange.emit(this._outputValue);
    }
  }

  private _outputValue: any[] = [];
  private _isInitialized = false;

  ngOnInit() {
    if (this.type === MultiSelectFilterType.MultiSelectItem) {
      this.fieldsSettings = DropDownConstantsFactory.createStandardClientDropdownSettings();
    }
    this.data = new DataManager({
      adaptor: new MultiSelectCustomAdaptor(this.getDataFunction),
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.isDisabled && changes.isDisabled.currentValue) {
      if (this.multiselect) {
        this.multiselect.setDisabledState(this.isDisabled);
      }
    }
  }

  public ngAfterViewInit() {
    this._isInitialized = true;
  }

  public refreshData() {
    this._outputValue = null;
    if (this.multiselect) {
      this.multiselect.refresh();
    }
  }
}
